import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { db } from '../firebase/firebaseConfig';
import { ref, onValue } from 'firebase/database';
import MaintenanceError from '../pages/MaintenanceError';

function MaintenanceGuard({ children }) {
  const [mode, setMode] = useState('off');
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    // Listen to real-time changes so the site instantly locks down or opens up
    // without requiring users to refresh the page.
    const modeRef = ref(db, 'settings/maintenanceMode');
    const unsubscribe = onValue(modeRef, (snapshot) => {
      if (snapshot.exists()) {
        const val = snapshot.val();
        // Fallback for previous boolean architecture
        setMode(val === true ? 'profiles' : (val === false ? 'off' : val));
      } else {
        setMode('off');
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div style={{height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#0d1117'}}>
        <div className="loader"></div>
      </div>
    );
  }

  const path = location.pathname;
  const isAdminRoute = path.startsWith('/admin');
  const isLoginRoute = path === '/login';
  const isProfileRoute = path.startsWith('/dev/') || path.startsWith('/embed/');

  // LEVEL 2: ENTIRE SITE BLOCKED (Except backend login & admin panel)
  if (mode === 'all' && !isAdminRoute && !isLoginRoute) {
    return <MaintenanceError />;
  }

  // LEVEL 1: PROFILES & EMBEDS BLOCKED
  if (mode === 'profiles' && isProfileRoute) {
    return <MaintenanceError />;
  }

  // LEVEL 0: ALL SYSTEMS GO
  return children;
}

export default MaintenanceGuard;
